export class AssitanceCaseProvider {
    id?: number;
    provider_id?: number;
    provider_site_id?: number;
    coverage_id?: number;
    case_id?: number;
    idProveedor?: number;
    claveProveedor?: number;
    name?: string;
    city?: string;
    state?: string;
    priority?: number;
    coverage_type?: number;
    lat?: number;
    lng?: number;
    plane?: string;
    price?: string;
    km_traveled?: string;
    provider?: any;
    provider_site?: any;
    coverage?: any;
}